import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useForm, Controller, FormProvider } from "react-hook-form";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { translationConstants } from "../../../../../constants";
import { allSharedComponents } from "../../../../../shared";
import { centersActions } from "../../../../../redux/actions";
import {
  appendMandatorySignAndTimezoneText,
  UTCWithTimezoneToISOString,
  dateObjectToServerFormat,
} from "../../../../../system";

const { FileUploader, ReactDatePickerWrapper, InputFieldWrapper } =
  allSharedComponents;

const UpdateNafesModal = (props) => {
  const methods = useForm();
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const formState = useSelector((state) => state.centerReducer.formState);

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = methods;

  const [validationErrorMessage, setValidationErrorMessage] = useState("");

  const onSubmit = (data) => {
    const dateString = dateObjectToServerFormat(data.documentExpiryDate);

    const formData = new FormData();
    formData.append("CenterId", props.centerId);
    formData.append("DocumentExpiryDateString", dateString);
    formData.append("Documents", data.documents[0]);
    dispatch(
      centersActions.updateNafes(
        formData,
        props.centerId,
        props.setupdateNafesModal
      )
    );
  };

  const handleFileUpload = useCallback(
    (file, key) => {
      setValue(key, file, { shouldValidate: true });
    },
    [setValue]
  );

  return (
    <div className="freelance-instructor-model-sm mb-4 pb-4">
      <p className="pricing-heading mt-3">
        {t(translationConstants.UPDATE_NAFES_DOCUMENT)}
      </p>
      <hr />
      <FormProvider {...methods}>
        <Form noValidate className="my-4" onSubmit={handleSubmit(onSubmit)}>
          <Container>
            <InputFieldWrapper
              md={12}
              controlId={"documents"}
              label={`${t(translationConstants.UploadDocument)}:`}
            >
              <div className="filterUploader">
                <FileUploader
                  sm
                  single
                  defaultValue={formState?.documents}
                  {...register("documents", {
                    required: t(translationConstants.imageRequired),
                  })}
                  onFileUpload={(file) => handleFileUpload(file, "documents")}
                  setValidationErrorMessage={setValidationErrorMessage}
                  isError={errors?.documents || validationErrorMessage}
                />
                {errors?.documents && !validationErrorMessage && (
                  <p className="errorText">{errors.documents.message}</p>
                )}
                {validationErrorMessage && (
                  <p className="errorText">{validationErrorMessage}</p>
                )}
              </div>
            </InputFieldWrapper>

            <InputFieldWrapper
              md={12}
              controlId={"documentExpiryDate"}
              label={appendMandatorySignAndTimezoneText(
                t(translationConstants.NAFAS_EXPIRY_DATE),
                t
              )}
            >
              <Controller
                name="documentExpiryDate"
                className="cursor-pointer"
                rules={{
                  required: t(translationConstants.expiryDateRequired),
                }}
                render={({ field }) => (
                  <ReactDatePickerWrapper
                    value={field.value}
                    selected={field.value}
                    minDate={new Date(UTCWithTimezoneToISOString())}
                    onChange={(date) => {
                      field.onChange(date);
                    }}
                  />
                )}
              />
              {errors.documentExpiryDate && (
                <p className="errorText">{errors.documentExpiryDate.message}</p>
              )}
            </InputFieldWrapper>

            <Row>
              <Col md={12} className="d-flex justify-content-center">
                <div className="w-100 d-flex mt-4  justify-content-center">
                  <Button type="submit" className="UpdateUserView-button mx-0">
                    {t(translationConstants.Update)}
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </Form>
      </FormProvider>
    </div>
  );
};

export default UpdateNafesModal;
